<template>
  <div>
    <section class="mobile_only faq_top_banner cat_in_top_banner cover">
      <div class="container"></div>
      <div class="bn_corner"></div>
    </section>
    <section class="contact_page faq_page no_banner_page clearfix">
      <div class="container">
        <div class="contact_main">
          <bread-crumbs :sub="bread"></bread-crumbs>
          <h1 class="cat_title">{{page.title}}</h1>
          <div class="text" v-html="page.post_content"></div>
          <h2 class="title">{{page.acf.subtitle}}</h2>
          <div class="all_careers" v-if="page.acf.faq">
            <div class="career_row toggleContainer" v-for="(faq, index) in page.acf.faq" :key="index">
              <div class="career_top ease">
                <a href="javascript:void(0);" onclick="toggle(this)">
                  {{faq.q}}
                  <span class="show_icon"></span>
                </a>
              </div>
              <div class="career_open toggleInner" v-html="faq.a"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="contact_side faq_side"></div>
    </section>
  </div>
</template>

<script>
  import BreadCrumbs from "../components/Breadcrumbs";
  export default {
    computed: {
      root: function() {
        return this.$root;
      },
      page: function() {
        return this.root.page;
      },
      bread: function() {
        return { name: this.page.title };
      }
    },
    components: {
      BreadCrumbs
    }
  };
</script>

<style scoped>
</style>